// DS: MO2.2
import React from 'react';
import c from 'classnames';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import CloseIconBold from '../Icons/CloseBold';
import { IconSize } from '../Icons/IconWrap';
import PlainButtonOrLink from '../Buttons/PlainButtonOrLink';
import s from './PreviewModeBar.scss';

interface Props {
  className?: string;
  onClose?: () => void;

  icon?: React.ReactNode;
  messageBeforeIcon: string;
  ctaLabel?: string;
  ctaHref?: string;
  ctaOnClick?: () => void;
  ctaBiData?: BiEvent;
}

const PreviewModeBar: React.FC<Props> = ({
  className,
  onClose,
  messageBeforeIcon,
  icon,
  ctaLabel,
  ctaHref,
  ctaOnClick,
  ctaBiData,
}) => {
  const renderCtaButton = () => {
    if (!ctaLabel) {
      return;
    }

    return (
      <PlainButtonOrLink
        className={s['cta-button']}
        href={ctaHref}
        onClick={ctaOnClick}
        biData={ctaBiData}
      >
        {ctaLabel}
      </PlainButtonOrLink>
    );
  };
  const renderCloseButton = () => {
    if (!onClose) {
      return;
    }
    return (
      <PlainButtonOrLink className={s['close-button']} onClick={onClose}>
        <CloseIconBold size={IconSize.SMALL} disableDefaultColors />
      </PlainButtonOrLink>
    );
  };

  return (
    <div className={c(s['root'], className)}>
      <div className={s['snackbar']}>
        {messageBeforeIcon && (
          <div className={s['message-before-icon']}>{messageBeforeIcon}</div>
        )}
        {icon}
        <div className={s['cta-button']}>{renderCtaButton()}</div>
      </div>
      {renderCloseButton()}
    </div>
  );
};

export default PreviewModeBar;
